"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDateTime = void 0;
/* eslint-disable import/prefer-default-export */
var timeConverter_1 = require("../../../utils/timeConverter");
var parseDateTime = function (data) {
    return {
        time: data ? (0, timeConverter_1.timeConverter)(data === null || data === void 0 ? void 0 : data.getUint32(0)) : undefined,
        timeUnix: data === null || data === void 0 ? void 0 : data.getUint32(0),
    };
};
exports.parseDateTime = parseDateTime;
